import React from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment';
import { Card,
   Spin, 
   Table, 
   Input, 
   InputNumber, 
   Form, 
   DatePicker, 
   TimePicker, 
   Select,
   Row,
   Popconfirm,
   Button,
   Icon,
   message,
  } from 'antd';
import RegistroIntro from 'components/fe/RegistroIntro.jsx';
import RegistroAlert from 'components/fe/RegistroAlert.jsx';
import { generateRange } from 'util/FormUtils.jsx';
import { EditableCell, EditableFormRow } from 'components/form/EditableCellTable.jsx';
import ModalWeeklySchedule from 'components/modal/ModalWeeklySchedule.jsx';
import ModalSingleSchedule from 'components/modal/ModalSingleSchedule.jsx';
import _ from 'lodash';

const FormItem = Form.Item;
const Textarea = Input.TextArea;
const Option = Select.Option;
const dateFormat = 'DD/MM/YYYY';
const timeFormat = 'HH:mm';

// TODO: inserire notificazione di antd e chiamate ajax
function createOptions(coll) {
  // console.warn('opts da passare: ', coll);
  if (coll && coll.length > 0) {
    return coll.map(formaDid => (
      <Option 
        key={formaDid.idFormaDidattica} 
        value={formaDid.idFormaDidattica}
      >{formaDid.descrizione}
      </Option>));
  }
  return;
}

class RegistroActivities extends React.Component {
  state = {
    argWidth: '300',
    columns: [
      {
        title: 'Data',
        dataIndex: 'data',
        key: 'day',
        render: data => data.format(dateFormat),
        editable: true,
        disableClickOutsideHandler: true,
        createComponent: (form,record,property,ref,onSave) => {
          return (
            <FormItem style={{ margin: 0 }}>
              {form.getFieldDecorator(property, {
                initialValue: record[property],
              })(
                <DatePicker
                  ref={ref}
                  format={dateFormat}
                  disabledDate={this.disabledDate}
                  onOpenChange={(status) => {
                    if (!status) {
                      onSave();
                    }
                  }}
                />
              )}
            </FormItem>
          );
        },
      },
      {
        title: 'Ora di inizio',
        dataIndex: 'data',
        key: 'time',
        render: data => data.format(timeFormat),
        editable: true,
        disableClickOutsideHandler: true,
        createComponent: function(form,record,property,ref,onSave) {
          return (
            <FormItem style={{ margin: 0 }}>
              {form.getFieldDecorator(property, {
                initialValue: record[property],
              })(
                <TimePicker
                  ref={ref}
                  format={timeFormat}
                  minuteStep={15}
                  allowClear={false}
                  onOpenChange={(status) => {
                    if (!status) {
                      onSave();
                    }
                  }}
                  addon={() => (
                    <Button size="small" type="primary" block onClick={onSave}>
                      OK
                    </Button>
                  )}
                />
              )}
            </FormItem>
          );
        },
      },
      { title: 'Durata (ore)',
        dataIndex: 'durata',
        key: 'durata',
        editable: true,
        createComponent: function(form,record,property,ref,onSave) {
          return (
            <FormItem style={{ margin: 0 }}>
              {form.getFieldDecorator(property, {
                initialValue: record[property],
              })(
                <InputNumber
                  ref={ref}
                  step={0.5}
                  max={12}
                />
              )}
            </FormItem>
          );
        },
      },
      {
        title: 'Argomento',
        dataIndex: 'argomento',
        key: 'argomento',
        width: '30%',
        editable: true,
        createComponent: function(form,record,property,ref,onSave) {
          return (
            <FormItem style={{ margin: 0 }}>
              {form.getFieldDecorator(property, {
                initialValue: record[property],
              })(
                <Textarea rows={2}
                  ref={ref}
                  onPressEnter={onSave}
                  maxLength={2000}
                />
              )}
            </FormItem>
          );
        },
      },
      {
        title: 'Modalità Erogazione',
        dataIndex: 'modalita',
        key: 'modalita',
        editable: true,
        disableClickOutsideHandler: true,
        createComponent: function(form,record,property,ref,onSave) {
          return (
            <FormItem style={{ margin: 0 }}>
              {form.getFieldDecorator(property, {
                initialValue: record[property],
              })(
                <Select
                  ref={ref}
                  onSelect={onSave}
                >
                  <Option key="nd" value={null}>Non Definito</Option>
                  <Option key="sinc" value="sincrona in presenza">Sincrona in presenza</Option>
                  <Option key="sinc" value="sincrona online">Sincrona online</Option>
                  <Option key="asinc" value="asincrona">Asincrona</Option>
                </Select>
              )}
            </FormItem>
          );
        },
      },
      {
        title: 'Aula/Piattaforma',
        dataIndex: 'aula',
        key: 'aula',
        editable: true,
        createComponent: function(form,record,property,ref,onSave) {
          return (
            <FormItem style={{ margin: 0 }}>
              {form.getFieldDecorator(property, {
                rules: [{
                    required: true,
                    message: `Il campo è obbligatorio`,
                }],
                initialValue: record[property],
              })(
                <Input
                  ref={ref}
                  onPressEnter={onSave}
                  maxLength={40}
                />
              )}
            </FormItem>
          );
        },
      },
      {
        title: 'Sede',
        dataIndex: 'sede',
        key: 'sede',
        editable: true,
        createComponent: function(form,record,property,ref,onSave) {
          return (
            <FormItem style={{ margin: 0 }}>
              {form.getFieldDecorator(property, {
                initialValue: record[property],
              })(
                <Input
                  ref={ref}
                  onPressEnter={onSave}
                  maxLength={256}
                />
              )}
            </FormItem>
          );
        },
      },
      {
        title: 'Forma didattica',
        dataIndex: 'idFormaDid',
        key: 'formaDid',
        editable: true,
        hasOptions: true,
        disableClickOutsideHandler: true,
        render: (idFomDid, row) => row.descFormaDid,
        createComponent: function(form,record,property,ref,onSave,opts) {
          return (
            <FormItem style={{ margin: 0 }}>
              {form.getFieldDecorator(property, {
                initialValue: record[property],
              })(
                <Select
                  ref={ref}
                  onSelect={onSave}
                >
                {opts}
                </Select>
              )}
            </FormItem>
          );
        },
      },
      {
        title: '',
        dataIndex: 'operation',
        width: '5%',
        render: (text, record) => (
          this.props.registryOccurrences.length >= 1 && this.props.registryInfo.stato === 'N'
            ? (
              <Popconfirm 
                title="Procedere con la cancellazione dell'attività?" 
                onConfirm={() => this.deleteRow(record)}
                okText="Sì"
                cancelText="No"
              >
                <Button type="danger">
                  <Icon type="delete" />
                </Button>
              </Popconfirm>
            ) : null
        ),
      }
    ],
  };

  updateRow = (row, cellName, cellValue) => {
    const occurrences = [];
    let retVal;
    const updatedRow = _.cloneDeep(row);
    updatedRow[cellName] = cellValue;
    occurrences.push(updatedRow);
    retVal = this.props.updateOccurrences(this.props.registryInfo.idRegistro, occurrences)
                  .then((response) => {
                    console.log('debug 8:', response);
                    if (response.error) {
                      return false;
                    }
                    console.log('debug 8: arrivato qua');
                    message.success('Modifica salvata con successo.');
                    return true;
                  });
    return retVal;
  }

  deleteRow = (record) => {
    console.warn('che riga devo cancellare?', record);
    // TODO: aggiungere chiamata ajax
    this.props.deleteOccurrences(this.props.registryInfo.idRegistro,record)
      .then((response) => {
        //TODO: handle notification
        console.warn(response);
        message.success('Cancellazione avvenuta correttamente.');
    });
  }

  disabledDate = (current) => {
    const rangeYears = generateRange(this.props.registryInfo.annoAccademico, 
      this.props.registryInfo.tipoCDL,
      null,
      this.props.registryInfo.dataChiusuraCopertura
      );
    // console.warn('range generato:', rangeYears);
    // console.warn('current: ', current, ' range of years:', rangeYears.minDate, '-', rangeYears.maxDate);
    return current && (current.isSameOrBefore(rangeYears.minDate) || current.isSameOrAfter(rangeYears.maxDate));
  }

  render() {
    const occurrences = this.props.registryOccurrences;
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };

    const cols = this.state.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      if (col.hasOptions) {
        return {
          ...col,
          onCell: record => ({
            record,
            editable: col.editable,
            disableClickOutsideHandler: col.disableClickOutsideHandler,
            dataIndex: col.dataIndex,
            title: col.title,
            handleSave: this.updateRow,
            createComponent: col.createComponent,
            hasOpts: createOptions(this.props.registryInfo.descFD),
          }),
        };
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          disableClickOutsideHandler: col.disableClickOutsideHandler,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.updateRow,
          createComponent: col.createComponent,
        }),
      };
    });

    switch (this.props.registryInfo.stato) {
      case 'C':
      case 'A':
      case 'Z':
        return (
          <Card
            title="Elenco Attività Registro"
            className="box box-solid box-unimi"
            bodyStyle={{ maxHeight: '600px', overflowY: 'scroll' }}
          >
            <Table
              rowKey="rId"
              className="registriTable"
              columns={this.state.columns}
              dataSource={occurrences}
              pagination={false}
              size="medium"
              bordered={false}
            />
          </Card>
        );
      case 'N':
      default:
        return (
          <Card
            title="Elenco Attività Registro"
            className="box box-solid box-unimi"
            bodyStyle={{ maxHeight: '600px', overflowY: 'scroll' }}
          >
            <RegistroAlert
              registryInfo={this.props.registryInfo}
            />
              {
                this.props.isLoaded && occurrences.length > 0 &&
                  <Spin
                    spinning={this.props.isEditing}
                    tip="Caricamento..."
                  >
                    <div className="row">
                      <div className="col-sm-10">
                        <p>
                          Attività attualmente inserite nel registro. <br />
                          Le attività vengono salvate automaticamente dopo ogni modifica.
                        </p>
                      </div>
                    </div>
                    <Row className="vmg10">
                      <Table
                        rowKey="rId"
                        className="registriTable"
                        columns={cols}
                        components={components}
                        dataSource={occurrences}
                        pagination={false}
                        bordered
                        size="middle"
                      />
                    </Row>
                    <Row gutter={16}>
                      <ModalSingleSchedule
                        registryInfo={this.props.registryInfo}
                        formeDidScheduled={this.props.registryInfo.descFD}
                        onSaveClick={this.props.onInsertByWeek}
                      />
                      <ModalWeeklySchedule
                        registryInfo={this.props.registryInfo}
                        registryOccurrences={this.props.registryOccurrences}
                        formeDidScheduled={this.props.registryInfo.descFD}
                        onSaveClick={this.props.onInsertByWeek}
                        title={{ button: 'Attività Multiple',
                                header: 'Inserisci nuove Attività Multiple',
                                step1: 'STEP 1: Arco temporale Attività Multiple',
                        }}
                      />
                    </Row>
                  </Spin>
              }
              {
              occurrences.length === 0 && this.props.isLoaded &&
                <div>
                  <RegistroIntro
                    weeklyButton={
                      <ModalWeeklySchedule
                        registryInfo={this.props.registryInfo}
                        formeDidScheduled={this.props.registryInfo.descFD}
                        onSaveClick={this.props.onInsertByWeek}
                        centered
                      />
                                  }
                    singleButton={
                      <ModalSingleSchedule
                        registryInfo={this.props.registryInfo}
                        formeDidScheduled={this.props.registryInfo.descFD}
                        onSaveClick={this.props.onInsertByWeek}
                        centered
                      />
                                  }
                  />
                </div>
              }
          </Card>
        );
    }
  }
}

RegistroActivities.propTypes = {
  registryInfo: PropTypes.object.isRequired,
  registryOccurrences: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoaded: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
  onInsertByWeek: PropTypes.func.isRequired,
  deleteOccurrences: PropTypes.func.isRequired,
  updateOccurrences: PropTypes.func.isRequired,
};

export { RegistroActivities };
